export default __webpack_public_path__ + "static/media/589.9d757afd.jpg";